import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const StarIconCD = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  return (
    <svg
      {...props}
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="60"
        cy="60"
        r="57.5"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="5"
      />
      <path
        d="M60.0002 33.0822L67.7422 50.8511L68.333 52.207L69.8059 52.342L89.23 54.1226L74.5964 66.8286L73.4649 67.8111L73.798 69.2721L78.0897 88.0925L61.2655 78.2187L60.0002 77.4761L58.7348 78.2187L41.9107 88.0925L46.2023 69.2721L46.5355 67.8111L45.4039 66.8286L30.7703 54.1226L50.1944 52.342L51.6673 52.207L52.2581 50.8511L60.0002 33.0822Z"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="5"
      />
    </svg>
  )
}

export default StarIconCD
